import { Mark, mergeAttributes } from "@tiptap/core"

// Custom mark that persists AI edit metadata through Tiptap's schema
const AiHighlight = Mark.create({
  name: "aiHighlight",

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  addAttributes() {
    return {
      "data-ai-action": { default: null },
      "data-ai-original": { default: null },
      "data-edit-id": { default: null },
      class: { default: "ai-editor-highlight" },
    }
  },

  parseHTML() {
    return [
      {
        tag: "mark.ai-editor-highlight",
      },
      {
        tag: 'mark[data-ai-action]',
      },
      {
        tag: "span.ai-editor-highlight",
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ["mark", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  },

  addCommands() {
    return {
      setAiHighlight: (attributes) => ({ commands }) => {
        return commands.setMark(this.name, attributes)
      },
      unsetAiHighlight: () => ({ commands }) => {
        return commands.unsetMark(this.name)
      },
    }
  },
})

export default AiHighlight
